import { success, warn } from 'styles/colorProvider';

export const formatComplaintStatus = (status) => {
  if (status === 'created') return { label: 'Reclamação aberta', color: success };
  if (status === 'updated') return { label: 'Atualização', color: warn };
  if (status === 'finished') return { label: 'Reclamação finalizada', color: success };
};
